
export enum AppDatatableEventType {
    ROW_SELECT = "row_select",
    CELL_UPDATE = "cell_update",
    ADD_ROW = "add_row",
    DELETE_ROW = "delete_row",
    CONTEXT_MENU = "context_menu",
    TABLE_CONTEXT = "table_context",
    TREE_EXPAND = "tree_expand"
}


// WEBPACK FOOTER //
// ./src/app/shared/datatable/enums/event-type.enum.ts